import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LeadModal from "@/components/LeadModal";
import MobileCTA from "@/components/MobileCTA";
import Ambient from "@/components/Ambient";
import HomePage from "@/pages/HomePage";
import SolutionsPage from "@/pages/SolutionsPage";
import CalculatorPage from "@/pages/CalculatorPage";
import AboutPage from "@/pages/AboutPage";
import ResourcesPage from "@/pages/ResourcesPage";
import FaqPage from "@/pages/FaqPage";
import ContactPage from "@/pages/ContactPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Shared site chrome — navbar, footer, lead modal and ambient layers persist
// across every page; only the routed content changes.
function Layout({ onLead, leadIntent, onCloseLead }) {
  return (
    <>
      <Navbar onLead={onLead} />
      <Outlet />
      <div className="relative z-10">
        <Footer />
      </div>
      <MobileCTA onLead={onLead} />
      <LeadModal intent={leadIntent} onClose={onCloseLead} />
    </>
  );
}

function App() {
  const [leadIntent, setLeadIntent] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -72, duration: 1.4 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="App bg-charcoal text-ivory font-sans overflow-x-clip">
      <div className="noise-overlay" aria-hidden="true" />
      <Ambient />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout onLead={setLeadIntent} leadIntent={leadIntent} onCloseLead={() => setLeadIntent(null)} />}>
            <Route path="/" element={<HomePage onLead={setLeadIntent} />} />
            <Route path="/solutions" element={<SolutionsPage onLead={setLeadIntent} />} />
            <Route path="/calculator" element={<CalculatorPage onLead={setLeadIntent} />} />
            <Route path="/about" element={<AboutPage onLead={setLeadIntent} />} />
            <Route path="/resources" element={<ResourcesPage onLead={setLeadIntent} />} />
            <Route path="/faq" element={<FaqPage onLead={setLeadIntent} />} />
            <Route path="/contact" element={<ContactPage onLead={setLeadIntent} />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#1C1A18",
            border: "1px solid rgba(229,192,123,0.35)",
            color: "#FDFBF7",
          },
        }}
      />
    </div>
  );
}

export default App;
